'use strict';

$(window).on('resize', function () {
  $('.pdf-popover').popover('hide');
  $('.dashboard-sharing-popover').popover('hide');
});
